module.exports = __webpack_public_path__ + "img/pluto27.00ce1cae.jpg";